// Rosewood → eigen checkout. NIET geïnstalleerd: pas na Neals ja (thema-wijziging op de live winkel).
// Plaatsen in theme.liquid vóór </body>: <script src="{{ 'rosewood-checkout.js' | asset_url }}" defer></script>
// Vangt elke klik/submit naar /checkout af, leest /cart.js en stuurt de klant met de wagen in de hash door.
// Ook cart token + cart-attributes (fbp, fbc, utm's … gezet door weTracked): die komen op de order, net als bij LASSO.
(function () {
  var CHECKOUT = 'https://pay.rosewood-jewelers.com/checkout'
  function b64url(s) { return btoa(unescape(encodeURIComponent(s))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '') }
  function go() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json() }).then(function (c) {
      if (!c.items || !c.items.length) return false
      var data = { cur: c.currency, tk: String(c.token || '').split('?')[0], a: c.attributes || {}, items: c.items.map(function (i) {
        return { v: i.variant_id, q: i.quantity, h: i.handle, t: i.product_title, vt: i.variant_title || '', p: i.final_price, cp: i.original_price > i.final_price ? i.original_price : null, img: i.image || '' }
      }) }
      location.href = CHECKOUT + '#c=' + b64url(JSON.stringify(data))
      return true
    })
  }
  function isCheckout(el) {
    if (!el) return false
    if (el.name === 'checkout') return true
    var href = el.getAttribute('href') || el.getAttribute('formaction') || ''
    return /^\/checkout(\/|\?|$)/.test(href)
  }
  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('a, button, input[type=submit]')
    if (!isCheckout(el)) return
    e.preventDefault(); e.stopPropagation()
    go().then(function (ok) { if (!ok) location.href = '/cart' }).catch(function () { location.href = '/checkout' })
  }, true)
})()
